
<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "relatorio-pro-formulario-resposta") {
            next({ name: "relatorio-pro-formulario-resposta-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "relatorio-pro-formulario-resposta") {
            this.$router.push({ name: "relatorio-pro-formulario-resposta-list" });
        }
    },
};
</script>
